import { render, staticRenderFns } from "./AsPageHeader.vue?vue&type=template&id=44c215f3"
import script from "./AsPageHeader.vue?vue&type=script&lang=js"
export * from "./AsPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports